<mat-card class="cardWithShadow dashboard-card dashboard-opportunity-card">
  <mat-card-content class="dashboard-card-content">
    <mat-card-title class="dashboard-card-title">
      {{ 'dashboard.opportunity_value' | translate }}
    </mat-card-title>
    <p class="dashboard-metric-label">{{ kpi().rangeLabel }}</p>
    <p class="dashboard-metric-value">{{ kpi().nonReimbursementTotal | currency }}</p>
    <app-oportunity-value-chart
      [filedNoReimbursementTotal]="kpi().filedNoReimbursementTotal"
      [unFiledClaimAmount]="kpi().unFiledClaimAmount"
      [unFiledClaimTotal]="kpi().unFiledClaimTotal"
      [filedNoReimbursementAmount]="kpi().filedNoReimbursementAmount"
      (claimsNotFiledSelected)="onClaimsNotFiledSelected()"
      (filedCasesNotReimbursedSelected)="onFiledCasesNotReimbursedSelected()" />
  </mat-card-content>
</mat-card>
